import axios from "axios";
import { getEnvVariables } from "../helpers/getEnvVariables";
const { API_URL } = getEnvVariables();

const axiosBase = axios.create({
    baseURL: API_URL,
    headers: { "Content-Type": "application/json" },
});

export default axiosBase;
